import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@chakra-ui/react";
import { useGetMembershipPaymentAction } from "../hooks";

interface Props {
  handleSubmit: () => void;
  isDisabled: boolean;
  isLoading: boolean;
}

export const SubmitButton: FC<Props> = ({
  handleSubmit,
  isDisabled,
  isLoading,
}) => {
  const { t } = useTranslation();
  const action = useGetMembershipPaymentAction();
  const base = `planPayment.${action}` as const;

  return (
    <Button
      isDisabled={isDisabled}
      isLoading={isLoading}
      onClick={handleSubmit}
      size="th-md"
      type="submit"
      w={{ base: "full" }}
      variant="th-primary"
    >
      {t(`${base}.submit`)}
    </Button>
  );
};
